import { useContext } from 'react';
import { UserContext, type User } from '../context/user-context.ts';

export function useUser(): User {
    const user = useContext(UserContext);

    if (!user) {
        throw new Error('useUser must be used within a UserContext provider');
    }

    return user;
}
